import axios from "axios";
import { getAuthToken } from "../params";
import { removeAuthToken } from "../params";
import Cookies from "universal-cookie";

//const BASE_URLP = import.meta.env.VITE_URL;
const EMPID = import.meta.env.VITE_EMPID;

// 2. Configura la URL base inyectando el cliente de forma automática
const BASE_URLP =  import.meta.env.BASE_URL;
/**
 * Axios para conexiones Publicas
 */
const SvrPubl = axios.create({
  baseURL: BASE_URLP,
});

SvrPubl.interceptors.request.use(
  (config) => {
    config.headers = { empresaid: EMPID };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

SvrPubl.interceptors.response.use(
  function (response) {
    if (response.status === 200 && response.data.error) {
      return Promise.reject({
        status: 0,
        message: response.data.message,
        Error: "Error de Validacion",
      });
    } else return response;
  },
  function (error) {
    if (error.response) {
      if ( error.response?.status === 404)
       {
         return Promise.reject({
         status: 0,
         message: "Error de conexion con el servidor, "+ error.response.message,
         Error: error.response,
       });
     }
   }

    if (!error) {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    } else {
      if (error.code) {
        if (error.code === "ERR_NETWORK") {
          return Promise.reject({
            status: 0,
            message: "Error de conexion con el servidor",
            Error: "Error de Conexion",
          });
        }
      } else return Promise.reject(error);
    }
  }
);

/**
 * Axios para conexiones Privadas
 */
const SvrConn = axios.create();
SvrConn.interceptors.request.use(
  async (config) => {
  //  const url = BASE_URLP;
    const token = await getAuthToken();
    const conf = config;
    conf.baseURL = BASE_URLP;
    conf.headers = {
      Authorization: `Bearer ${token}`,
    };
    return conf;
  },
  (error) => {
    return Promise.reject(error);
  }
);

SvrConn.interceptors.response.use(
  function (response) {
    
    //captura los errores personalizado y los pasa a la interfaz para ser visualizado...
    if (response.status === 200 && response.data.error) {
      return Promise.reject({
        status: 0,
        message: response.data.message,
        Error: "Error de Validacion",
      });
    } else return response;
  },
  function (error) {
    
    //const navigate = useNavigate();
    if (!error) {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    } else {
      if (error.code) {
        if (error.code === "ERR_NETWORK") {
          return Promise.reject({
            status: 0,
            message:
              "Error de conexion con el servidor, verifique su conexión de red",
            Error: "Error de Conexion",
          });
        }

        if (error.code === "ERR_BAD_REQUEST") {
          if (error.response) {
            if (
              error.response?.status === 403 &&
              error.response?.data?.token === false
            ) {
              removeAuthToken();
              window.location = "/";
            } else {
              return Promise.reject({
                status: 0,
                message: error.response.message,
                Error: "Error de Validacion",
              });
            }
          } else {
            return Promise.reject({
              status: 0,
              message: error.message,
              Error: "Error de Conexion",
            });
          }
        }
      } else return Promise.reject(error);
    }
  }
);
/**
 * Axios para conexiones Privadas
 */
const SvrConnIm = axios.create();
SvrConnIm.interceptors.request.use(
  async (config) => {
    //const url = BASE_URLP;
    const token = await getAuthToken();
    const conf = config;
    conf.baseURL = BASE_URLP;
    conf.headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    };
    return conf;
  },
  (error) => {
    return Promise.reject(error);
  }
);

SvrConnIm.interceptors.response.use(
  function (response) {
    //captura los errores personalizado y los pasa a la interfaz para ser visualizado...
    if (response.status === 200 && response.data.error) {
      return Promise.reject({
        status: 0,
        message: response.data.message,
        Error: "Error de Validacion",
      });
    } else return response;
  },
  function (error) {
    //const navigate = useNavigate();
    if (!error) {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    } else {
      if (error.code) {
        if (error.code === "ERR_NETWORK") {
          return Promise.reject({
            status: 0,
            message:
              "Error de conexion con el servidor, verifique su conexión de red",
            Error: "Error de Conexion",
          });
        }

        if (error.code === "ERR_BAD_REQUEST") {
          if (error.response) {
            if (
              error.response?.status === 403 &&
              error.response?.data?.token === false
            ) {
              removeAuthToken();
              window.location = "/";
            } else {
              return Promise.reject({
                status: 0,
                message: error.response.message,
                Error: "Error de Validacion",
              });
            }
          } else {
            return Promise.reject({
              status: 0,
              message: error.message,
              Error: "Error de Conexion",
            });
          }
        }
      } else return Promise.reject(error);
    }
  }
);

/**
 * Axios para conexiones Publicas con API KEY
 */
const SvrAPk = axios.create({
  baseURL: BASE_URLP,
});

SvrAPk.interceptors.request.use(
  (config) => {
    config.headers = { Empresaid: EMPID };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

SvrAPk.interceptors.response.use(
  function (response) {
    if (response.status === 200 && response.data.error) {
      return Promise.reject({
        status: 0,
        message: response.data.message,
        Error: "Error de Validacion",
      });
    }

    return response;
  },

  function (error) {
    if (!error) {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    }

    if (error.code === "ERR_NETWORK") {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    }

    return Promise.reject(error);
  }
);
//----------------------------------------------------------------------------------------------------------------------
const SvrWtlss = axios.create({
  baseURL: '',
});

SvrWtlss.interceptors.request.use(
  (config) => {
    config.headers = { Empresaid: EMPID };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

SvrWtlss.interceptors.response.use(
  function (response) {
    if (response.status === 200 && response.data.error) {
      return Promise.reject({
        status: 0,
        message: response.data.message,
        Error: "Error de Validacion",
      });
    }

    return response;
  },

  function (error) {
    if (!error) {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    }

    if (error.code === "ERR_NETWORK") {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    }
    if (error.code === "ERR_BAD_REQUEST") {
      if (error.response) {
        if (
          error.response?.status === 403 &&
          error.response?.data?.token === false
        ) {
          removeAuthToken();
          window.location = "/";
        } else {
          const detail = error.response?.data?.detail;

          let message = "Error de validación";

          if (Array.isArray(detail)) {
            message = detail.map((e) => `${e.loc?.join(".")}: ${e.msg}`).join(", ");
          } else if (typeof detail === "string") {
            message = detail;
          } else if (error.response?.data?.message) {
            message = error.response.data.message;
          } else if (error.message) {
            message = error.message;
          }

          return Promise.reject({
            status: error.response?.status ?? 0,
            message,
            Error: "Error de Validacion",
          });
        }
      } else {
        return Promise.reject({
          status: 0,
          message: error.message,
          Error: "Error de Conexion",
        });
      }
    }    
    return Promise.reject(error);
  }
);

/**
 * Axios para conexiones con impresora
 */
const SvrPrnt = axios.create({

});

SvrPrnt.interceptors.request.use(
  async (config) => {
    const url = await getConexions();
    const conf = config;
    conf.baseURL = url;
    conf.headers = {"Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "POST,GET",
                    "Access-Control-Allow-Private-Network": "true",
                    }
    return conf;
  },
  (error) => {
    return Promise.reject(error);
  }
);

SvrPrnt.interceptors.response.use(
  function (response) {
    //captura los errores personalizado y los pasa a la interfaz para ser visualizado...
    if (response.status === 200 && response.data.error) {
      return Promise.reject({
        status: 0,
        message: response.data.message,
        Error: "Error de Validacion",
      });
    } else return response;
  },
  function (error) {
    if (!error) {
      return Promise.reject({
        status: 0,
        message: "Error de conexion con el servidor",
        Error: "Error de Conexion",
      });
    } else {
      if (error.code) {
        if (error.code === "ERR_NETWORK") {
          return Promise.reject({
            status: 0,
            message: "Error de conexion con el servidor",
            Error: "Error de Conexion",
          });
        }
      } else return Promise.reject(error);
    }
  }
);

const getConexions = async () => {
  const Direccion = "127.0.0.1";
  let cookies = new Cookies();
  let Puerto = cookies.get('Puerto');

  let Protocolo = window.APP_CONFIG?.PRINTER_PROTOCOL || 'http';
  
  if (!Puerto) Puerto = '8080';

  // Cambiamos http por https
  const apiUrl = Protocolo+"://" + Direccion + ":" + Puerto + "/";

  return apiUrl;
};
export { SvrPubl, SvrConn, SvrAPk, SvrPrnt, SvrConnIm, SvrWtlss, getConexions };
